
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateBuildingserviceDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(500)]),
    shortname: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true),
})
;
}
      